export default "__VITE_ASSET__HUvGg0Wx__"